import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { styled } from '@mui/material/styles';

// Styled Alert to vertically center the icon
const CenteredAlert = styled(MuiAlert)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& .MuiAlert-icon': {
    alignSelf: 'center', // center icon vertically even for multiline text
    marginTop: 0,
  },
  '& .MuiAlert-message': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    lineHeight: 1.4,
  },
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <CenteredAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const HomeToastMessage = ({ message, severity, open, handleClose }) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={handleClose} severity={severity}>
        {typeof message === 'string' ? <span>{message}</span> : message}
      </Alert>
    </Snackbar>
  );
};

export default HomeToastMessage;
